import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=1d2669dc&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"
import style0 from "./logout.vue?vue&type=style&index=0&id=1d2669dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2669dc",
  null
  
)

export default component.exports